import styled from '@emotion/styled';
import { ButtonLegacy } from '../../_Button';

export const StyledChatButtonContainer = styled.div(({ theme }) => ({
    position: 'fixed',
    zIndex: theme.zIndices[1],
    right: theme.spaces[3],
    bottom: theme.spaces[3],
    overflow: 'hidden',
    borderRadius: 100, // Arbitrary high value to make sure we cover. Can't use percentage because button is oblong
}));

export const StyledChatButton = styled(ButtonLegacy)({
    border: 'none',
    backgroundColor: 'rgb(95, 197, 80)',
    fill: 'rgb(40, 66, 36)',
    padding: 15,
    ['svg']: {
        height: 38,
        width: 38,
    },
    '&:hover': {},
});
